@if (site$ | async; as site) {
  <glxy-page>
    <glxy-page-toolbar>
      <glxy-page-title>
        {{ 'NAVIGATION.TABS.OVERVIEW' | translate }}
      </glxy-page-title>
      <glxy-page-actions>
        @if (editRedirectURL$ | async; as editUrl) {
          <button
            data-action="wordpress-edit-site"
            data-action-group="open-wordpress"
            mat-flat-button
            color="primary"
            (click)="navigateToEditSite(site.siteId, editUrl)"
          >
            <mat-icon>create</mat-icon>
            {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.EDIT_MY_SITE' | translate }}
          </button>
        }
        <a class="toolbar-help-button" mat-icon-button target="_blank" href="https://websitepro.zendesk.com/hc/en-us">
          <mat-icon>help_outline</mat-icon>
        </a>
      </glxy-page-actions>
    </glxy-page-toolbar>
    @if (showCloudArmorBanner) {
      <glxy-alert type="info" [showClose]="true" (close)="closeCloudArmor()">
        {{ 'BANNER.CLOUD_ARMOR.TEXT' | translate }}
        <a href="https://websitepro.zendesk.com/hc/en-us/articles/28162842499991-Google-Cloud-Armor" target="_blank">
          {{ 'BANNER.CLOUD_ARMOR.LEARN_MORE' | translate }}
        </a>
      </glxy-alert>
      <br />
    }
    @if ((isPartner$ | async) && showSupportUpgradeBanner) {
      <glxy-alert type="info" [showClose]="true" (close)="closeSupportUpgradeBanner()">
        {{ 'BANNER.SUPPORT_UPGRADE.TEXT' | translate }}
        <br />
        {{ 'BANNER.SUPPORT_UPGRADE.TEXT_2' | translate }}
        <a href="https://feedback.vendasta.com/changelog/upgrades-to-our-support-system-on-march-30th-2026" target="_blank" rel="noopener noreferrer">
          {{ 'BANNER.SUPPORT_UPGRADE.LEARN_MORE' | translate }}
        </a>
      </glxy-alert>
      <br />
    }
    @if (loadingPhpVersion === false) {
      @if (phpVersion === '7') {
        <glxy-alert
          type="warning"
          [showAction]="true"
          actionTitle="{{ 'BANNER.PHP_UPGRADE.ACTION' | translate }}"
          (actionClick)="updatePHP()"
        >
          <strong>{{ 'BANNER.PHP_UPGRADE.TITLE' | translate }}</strong>
          &mdash; {{ 'BANNER.PHP_UPGRADE.TEXT' | translate }}
          <a href="https://help.websitepro.hosting/?p=583" target="_blank">
            {{ 'BANNER.PHP_UPGRADE.LEARN_MORE' | translate }}
          </a>
        </glxy-alert>
        <br />
      } @else if (phpVersion === '8.1' && showPhp81Banner) {
        <glxy-alert type="info" [showClose]="true" (close)="closePhp81Banner()">
          {{ 'BANNER.PHP_UPGRADE.MULTIPLE_PHP_8' | translate }}
        </glxy-alert>
        <br />
      }
    } @else {
      <mat-spinner class="info-spinner" color="accent" [diameter]="30" [strokeWidth]="4"></mat-spinner>
      <br />
    }
    @if ((gaViewNotFound$ | async) === false && (ga4ViewNotFound$ | async) === true) {
      @if ((connectGALinkLoading$ | async) === false) {
        @if ((connectGALinkError$ | async) === false) {
          <glxy-alert
            type="warning"
            [showAction]="true"
            actionTitle="{{ 'BANNER.GOOGLE_ANALYTICS.ACTION' | translate }}"
            (actionClick)="connectGA4()"
          >
            <strong>{{ 'BANNER.GOOGLE_ANALYTICS.TITLE' | translate }}</strong>
            &mdash; {{ 'BANNER.GOOGLE_ANALYTICS.TEXT' | translate }}
            <a
              href="https://websitepro.zendesk.com/hc/en-us/articles/27640091554583-Add-Your-Own-Google-Analytics-Account"
              target="_blank"
            >
              {{ 'BANNER.GOOGLE_ANALYTICS.LEARN_MORE' | translate }}
            </a>
          </glxy-alert>
          <br />
        } @else {
          <mat-spinner class="info-spinner" color="accent" [diameter]="60" [strokeWidth]="8"></mat-spinner>
        }
      } @else {
        <mat-spinner class="info-spinner" color="accent" [diameter]="60" [strokeWidth]="8"></mat-spinner>
      }
    }
    <glxy-page-wrapper [maxWidth]="1200">
      <div class="row row-gutters">
        <div class="col col-sm-12 col-md-4">
          <app-manage-site
            [siteId]="site.siteId"
            [domain]="site.domain"
            [partnerId]="site.partnerId"
            [editURL]="editRedirectURL$ | async"
            [siteUpdate]="siteUpdate$ | async"
            [siteUpdateErr]="siteUpdateErr"
          />
          <app-manage-template-card [siteId]="site.siteId" [site]="site" />
          <app-cdn-card />
          <app-purge-cache-card />
        </div>
        <div class="col col-sm-12 col-md-8">
          <div>
            <app-uptime-report [siteId]="site.siteId" [partnerId]="site.partnerId" />
          </div>
          <div>
            @if ((ga4ViewNotFound$ | async) === false) {
              <app-ga4-overview-metrics [siteId]="site.siteId" />
            }
          </div>
          <div>
            @if ((gaViewNotFound$ | async) === false && (ga4ViewNotFound$ | async) === true) {
              <app-ga-overview-metrics [siteId]="site.siteId" />
            }
          </div>
          <div [class.safari-only-speed-score-margin]="isSafari()">
            <app-speed-score [domain]="site.domain" [siteId]="site.siteId" />
          </div>
          <div>
            <app-vital-metrics [domain]="site.domain" />
          </div>
        </div>
      </div>
    </glxy-page-wrapper>
  </glxy-page>
}
